// extracted by mini-css-extract-plugin
module.exports = {"content":"Customization_content__3Hm5O","submitBtn":"Customization_submitBtn__vFizk"};